import React, { useEffect, useState, useCallback } from "react";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import css from "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import Modal from "components/base/Modal";
import nonsubscriber from "assets/images/non-subscriber.svg";
import { openClickToDial } from "data/user/actions";
import { selectUserId, selectProfile, selectPlanDetails, isLegacyAccountPlan, selectIsClickToDialOpen } from "data/user/selectors";
import { getPlanDetails } from "data/user/actions";

import { goToLeadAutomatorUpgrade } from "../../../app/AccountNew/Sections/LeadAutomator";
import LeaveMessagePopup from "../../../app/AccountNew/modals/LeaveMessage";
import ActivateSubscriptionPopup from "../../../app/AccountNew/modals/ActivateSubscription";

const UpgradeToLeadAutomator = ({ history }) => {
  const dispatch = useDispatch();

  const userId = useSelector(selectUserId);
  const planDetails = useSelector(selectPlanDetails)?.toJS();
  const isLegacyAccount = useSelector(isLegacyAccountPlan);
  const isClickToDialOpen = useSelector(selectIsClickToDialOpen);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isClickToDialOpen);
  }, [isClickToDialOpen]);

  useEffect(() => {
    if (userId) {
      dispatch(getPlanDetails(userId));
    }
  }, [userId]);

  const leaveMessagePopup = useCallback(
    (options) => {
      dispatch(LeaveMessagePopup.open(options));
    },
    [dispatch],
  );

  const goToLeadAutomator = useCallback(() => {
    goToLeadAutomatorUpgrade({
      planDetails,
      isLegacyAccount,
      dispatch,
      history,
      leaveMessagePopup,
      onSuccess: () => {
        dispatch(openClickToDial(false));
      },
      onCancel: () => {
        setIsOpen(true);
      }
    });
  }, [planDetails, isLegacyAccount, dispatch, history, leaveMessagePopup]);

  const handleUpgradeNow = () => {
    if(!planDetails) {
      return;
    }

    setIsOpen(false);

    // Check if user is on trial
    if (planDetails?.trialAvailable) {
      // Trial user - show Activate Subscription modal
      dispatch(
        ActivateSubscriptionPopup.open({
          upgradedFromCallSettings: true,
          onNavigate: (path) => {
            history.push(path);
          },
          onClose: () => {
            dispatch(openClickToDial(false));
          },
          onSuccess: () => {
            setIsOpen(true);
          },
        }),
      );
    } else {
      // Regular user (non Lead Automator subscriber) - show Lead Automator upgrade
      goToLeadAutomator();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      isCloseButton={false}
      uniqId="UpgradeToLeadAutomatorModal"
      borderRadius="12px"
      zIndex={998}
      modalClassName={css.upgradeToLeadAutomatorModal}
      className={classNames(css.clsClickToDialModals)}
      onClose={() => dispatch(openClickToDial(false))}
    >
      <div>
        <div className={css.clsWrapper}>
          <div className={css.clsTitle}>
            <span>Make Calls Inside PropStream Today!</span>
          </div>

          <div className={css.clsMain}>
            <div>
              <img src={nonsubscriber} alt="nonsubscriber" />
            </div>

            <div className={css.clsContent}>
              <span className={css.clsText}>
                Click to Dial is part of our Lead Automator subscription. Upgrade your plan to start making calls
                directly from PropStream and streamline your lead outreach.&nbsp;
                <span
                  className={css.urlOpener}
                  onClick={() => {
                    window.open("https://www.propstream.com/lead-automator", "_blank", "noopener,noreferrer");
                  }}
                >
                  Learn More
                </span>
              </span>

              <div className={css.clsBtnWrapper}>
                <button className={css.cancelBtn} onClick={() => dispatch(openClickToDial(false))}>
                  <span className={css.cancelBtnLabel}>Cancel</span>
                </button>

                <button className={css.upgradeBtn} onClick={handleUpgradeNow}>
                  <span className={css.upgradeBtnTxt}>Upgrade Now</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default withRouter(UpgradeToLeadAutomator);
